import config from 'src/globals';
import { GET_MASTER_DATA } from './routes';
import { GET } from 'src/network/apiHandler';

export const getMasterData = async () => {
  const response = await GET(`${config.API_BASE_URL}${GET_MASTER_DATA}`);
  return response;
};
